import React from 'react'
import { Label } from '../input/input'
import { SubmitButton } from '../input/button'
import './style.css'

export const ResetForm = ({
  newPassword,
  handleNewPasswordInputChange,
  confirmPassword,
  setForm,
  loading,
  onSubmit,
}) => (
  <div className="form-container">
    <h2 className="signin-title">Nueva contraseña</h2>
    <p className="signin-subtitle">
      Ingresa tu nueva contraseña. Debe tener al menos 6 caracteres.
    </p>
    <div className="form-group">
      <Label value="Nueva contraseña" />
      <input
        className="input-base"
        type="password"
        value={newPassword}
        name="newPassword"
        placeholder="Nueva contraseña"
        onChange={handleNewPasswordInputChange}
      />
    </div>
    <div className="form-group">
      <Label value="Confirmar contraseña" />
      <input
        className="input-base"
        type="password"
        value={confirmPassword}
        name="confirmPassword"
        placeholder="Repite tu contraseña"
        onChange={handleNewPasswordInputChange}
      />
    </div>
    <SubmitButton
      text="Cambiar Contraseña"
      onClick={onSubmit}
      loading={loading}
      loadingText="Actualizando..."
      type="button"
    />
    <div className="recover-text" style={{ marginTop: '1.5rem' }}>
      ¿Recordaste tu contraseña?{' '}
      <span className="signin-recover-text" onClick={() => setForm('login')}>
        Volver al inicio
      </span>
    </div>
  </div>
)
